<template>
    <switcher :unique-id="uniqueId"
              :is-active="isActiveComputed"
              :text="text"
              :text-inactive="textInactive"
              :is-disabled="isDisabledComputed"
              :styles="stylesComputed"
              @changed="exportChange"
    ></switcher>
</template>

<script>
import externalPropsParser from 'services/utils/externalPropsParser';
import Switcher from 'components/Switcher.vue';
import eventBus from '@/mixins/eventBus';
import externalParsedProps from '@/mixins/externalParsedProps';

const parsedProps = ['isActive', 'isDisabled', 'styles'];

export default {
    name: 'SwitcherEx',
    mixins: [
        eventBus('switcher-ex'),
        externalParsedProps(Switcher.props, parsedProps)
    ],
    props: externalPropsParser.setExternalProps(Switcher.props, parsedProps),
    methods: {
        exportChange(data) {
            this.$emit('changed', data);
        }
    },
    components: { Switcher }
};
</script>
